import RotDocuments from '../rot-documents.component'

const EsignOnly = (props) => {
  return <RotDocuments {...props}/>
}

export default EsignOnly